<script>
/**
 * Original Author: Dallin Anderson
 * Original Team: BFFs
 */
// This component wraps each child component in a div that handles styling when
// selected and emits a "select" event

export default {
  name: 'NsSlottedDropdownItems',
  props: {
    dense: Boolean,
    modal: Boolean,
    selected: {
      type: [String, Number],
      default: null,
    },
    showAll: Boolean,
    usingCustom: Boolean,
  },
  methods: {
    handleClick(e, index) {
      e.stopPropagation();
      const vNode = this.$slots.default[index];
      const value = vNode.data.attrs['data-value'] || index;
      this.$emit('select', value, index);
    },
    isSelected(index) {
      const vNode = this.$slots.default[index];
      const value = vNode.data.attrs['data-value'];

      if (value) {
        return this.usingCustom
          ? value === 'custom'
          : String(this.selected) === String(value);
      } else {
        return this.selected === index;
      }
    },
  },
  render(createElement) {
    if (!this.$slots.default) {
      return null;
    }

    return createElement(
      'div',
      {
        class: [
          this.$style.container,
          {
            [this.$style.showAll]: this.showAll,
            [this.$style.modal]: this.modal,
          },
        ],
      },
      this.$slots.default.map((child, index) =>
        createElement(
          'div',
          {
            class: [
              this.$style.item,
              {
                [this.$style.selected]: this.isSelected(index),
                [this.$style.dense]: this.dense,
              },
            ],
            on: {
              click: (e) => this.handleClick(e, index),
            },
            ref: `item-${index}`,
          },
          [child]
        )
      )
    );
  },
};
</script>

<style lang="scss" module>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/other";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";
@use '~@nuskin/ns-core-styles/src/scss/global.mixins';

.container {
  max-height: 212px;
  background-color: white;
  overflow-y: auto;

  &.showAll {
    max-height: unset;
  }

  &.modal {
    max-height: unset;

    .item {
      padding: 10px 15px;
      background-color: unset;

      &.selected::before {
        height: 100%;
      }
    }
  }
}

.item {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-top: 1px solid map.get(colors.$themeColors, color-gray-4);
  padding: 0 10px;
  min-height: 37px;
  // height: 37px;
  background-color: white;
  transition: map.get(other.$otherUtils, global-transition) !important;
  white-space: nowrap;

  &.dense {
    min-height: 30px;
  }

  &:first-child {
    border-top: none;
  }

  &:hover {
    background-color: map.get(colors.$themeColors, color-interactive-5);
  }

  &.selected {
    color: map.get(colors.$themeColors, color-interactive-7);
    font-weight: map.get(typographyVariables.$typography, font-weight-semibold);

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 3px;
      height: calc(100% - 8px);
      background-color: map.get(colors.$themeColors, color-interactive-7);
    }
  }
}

@media (min-width: 768px) {
  .item {
    @include global.p-small;
  }
}
</style>
